import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=7786e3b9&"
import script from "./SubHeader.vue?vue&type=script&lang=js&"
export * from "./SubHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VIcon,VToolbar})
